var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinFalse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lets-icons:pin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.53759 2.28095C8.9185 2.02662 9.10925 1.89945 9.31634 1.92045C9.524 1.94087 9.68559 2.10245 10.0093 2.4262L11.5738 3.9907C11.8976 4.31445 12.0592 4.47604 12.0796 4.6837C12.1 4.89137 11.9734 5.08154 11.7197 5.46245L10.7572 6.90504C10.4299 7.39679 10.266 7.64237 10.1353 7.90487C10.0384 8.0993 9.95518 8.30026 9.88625 8.50629C9.79292 8.78454 9.73459 9.07445 9.61909 9.6537L9.50825 10.2108L9.50709 10.2143C9.48792 10.3088 9.44563 10.3971 9.384 10.4712C9.32236 10.5454 9.24331 10.6031 9.1539 10.6392C9.0645 10.6753 8.96754 10.6887 8.87169 10.6782C8.77584 10.6677 8.6841 10.6335 8.60467 10.5789L8.60175 10.5765L8.586 10.566C6.56856 9.16797 4.81975 7.41758 3.4235 5.39887L3.42117 5.39537C3.3665 5.31594 3.33238 5.2242 3.32185 5.12835C3.31132 5.0325 3.32471 4.93554 3.36083 4.84614C3.39695 4.75673 3.45467 4.67768 3.52882 4.61604C3.60298 4.55441 3.69125 4.51212 3.78575 4.49295L3.78925 4.49237L4.34634 4.38095C4.92559 4.26487 5.2155 4.20712 5.49375 4.11379C5.69958 4.04483 5.90035 3.9616 6.09459 3.8647C6.35709 3.73404 6.60325 3.57012 7.095 3.24229L8.53759 2.28095Z",
    stroke: "#00A0AF",
    strokeWidth: 1.16667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.91602 11.0835L5.54102 8.4585",
    stroke: "#00A0AF",
    strokeWidth: 1.16667,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5477",
    x: 4,
    y: 1.81348,
    width: 1,
    height: 12,
    transform: "rotate(-23.9923 4 1.81348)",
    fill: "#5FAAB3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5478",
    x: 4.91406,
    y: 1.40674,
    width: 1,
    height: 12,
    transform: "rotate(-23.9923 4.91406 1.40674)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinFalse);
export default __webpack_public_path__ + "static/media/pin-false.2ccd4df0a3108352203034ae8f8081d6.svg";
export { ForwardRef as ReactComponent };